export default __webpack_public_path__ + "static/media/Christine.82831a77.jpg";